import { render, staticRenderFns } from "./TrainingEventEdit.vue?vue&type=template&id=ad477d72"
import script from "./TrainingEventEdit.vue?vue&type=script&lang=js"
export * from "./TrainingEventEdit.vue?vue&type=script&lang=js"
import style0 from "./TrainingEventEdit.vue?vue&type=style&index=0&id=ad477d72&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports